<template>
  <div class="stat-container">
    <div class="row my-2 px-3">
      <div class="col-2">
        <font-awesome-icon
          icon="chart-line"
          class="stat-icon dont-print"
        />
      </div>
      <div class="col-2">
        <span class="stat-title">{{ $t('contract_reports.assignment.total') }}</span>
        <span class="stat-text"> {{ total }} </span>
      </div>
      <div class="col-2">
        <span class="stat-title">{{ $t('contract_reports.assignment.new') }}</span>
        <span class="stat-text"> {{ newAs }} </span>
      </div>
      <div class="col-2">
        <span class="stat-title">{{ $t('contract_reports.assignment.closed') }}</span>
        <span class="stat-text"> {{ closed }} </span>
      </div>
      <div class="col-2">
        <span class="stat-title">{{ $t('contract_reports.assignment.open') }}</span>
        <span class="stat-text"> {{ open }} </span>
      </div>
    </div>
    <div class="row my-2 px-3">
      <div class="col-2">
        <font-awesome-icon
          icon="clock"
          class="stat-icon dont-print"
        />
      </div>
      <div class="col-2">
        <span class="stat-title">{{ $t('defects.average_age') }} </span>
        <span class="stat-text">{{ getWorkDays(average) }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: 'WorkAssignmentSummaryValues',
    mixins: [timeUtils],
    props: {
        total: Number,
        newAs: Number,
        open: Number,
        closed: Number,
        average: Number

    },

}

</script>

<style>
</style>
